// From file-upload bundle
import { FileService } from '../../file-upload/service/FileService';
var layers = null;
export var getLayers = function getLayers(callback) {
  if (layers && layers.length) {
    callback(layers);
    return;
  }
  var service = Oskari.getSandbox().getService('Oskari.mapframework.service.MapLayerService');
  FileService.listLayersWithFiles(function (layersJSON) {
    // write to "global"
    layers = layersJSON.map(function (json) {
      var mapLayer = service.createMapLayer(json);
      // unsupported maplayer type returns null so check for it
      if (mapLayer) {
        service.addLayer(mapLayer);
        return mapLayer;
      }
    }
    // filter out null layers (unsupported)
    ).filter(function (layer) {
      return !!layer;
    });
    // call render
    callback(layers);
  }, true);
};
export var getLayerFromService = function getLayerFromService(id) {
  var service = Oskari.getSandbox().getService('Oskari.mapframework.service.MapLayerService');
  return service.findMapLayer(id);
};